<h1>Dev Tool</h1>

<form [formGroup]="devModeForm" (ngSubmit)="onSubmit()">
  <mat-form-field appearance="fill" style="width: 100%">
    <mat-label>Impersonate user</mat-label>
    <mat-select formControlName="userId">
      <mat-option value="">-- Select User --</mat-option>
      @for (user of users; track user.id) {
        <mat-option [value]="user.id"> {{ user.name }} (ID: {{ user.id }}) </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <div style="display: flex; gap: 8px; margin-top: 16px">
    <button mat-flat-button color="primary" type="submit" [disabled]="!devModeForm.value.userId">Apply</button>
    <button mat-button type="button" (click)="onReset()">Reset</button>
  </div>
</form>
